export const DBRE_EMAILS = [
  'milla.oliveira@blip.ai',
  'sergio.maruki@blip.ai',
];

export const CEZAR_SILVA_EMAILS = [
  'cezar.silva@blip.ai',
];

export const PRISCILA_EMAILS = [
  'priscila.portes@blip.ai',
  'priscila.portes@stilingue.com.br',
];

export const JANDEILSON_BORGES_EMAILS = [
  'jandeilson.borges@blip.ai',
  'jandeilson@stilingue.com.br',
];

export const MAYARA_OLIVEIRA_EMAILS = [
  'mayara.oliveira@blip.ai',
  'mayara@stilingue.com.br',
];

export const LIBERACOES_EMAILS = [
  ...PRISCILA_EMAILS,
  ...JANDEILSON_BORGES_EMAILS,
  ...MAYARA_OLIVEIRA_EMAILS,
  ...CEZAR_SILVA_EMAILS,
  'ricardo.silva@blip.ai',
  'andre.cesari@blip.ai',
  'laura.viana@blip.ai',
  'laura.viana@stilingue.com.br',
  'andreza.melo@blip.ai',
  'emanuelli.silva@blip.ai',
  'andre.martins@stilingue.com.br',
  'emanuelli.silva@take.net',
  'michele.andrade@blip.ai',
  'angelo.finassi@blip.ai',
  'laura.lima@stilingue.com.br'
];

export const N1_EMAILS = [
  'bruna.teixeira@blip.ai',
  'bruna.freitas@stilingue.com.br',
  'alice.faria@blip.ai',
  'alice.faria@stilingue.com.br',
  'barbara.osik@blip.ai',
  'barbara.osik@stilingue.com.br',
  'bruna.teixeira@stilingue.com.br',
  'jose.castelao@blip.ai',
  'jose.castelao@stilingue.com.br',
  'sayonara.ribeiro@blip.ai',
  'sayonara.ribeiro@stilingue.com.br',
  'gabriel.novaes@blip.ai',
  'gabriel.novaes@stilingue.com.br',
  'thayene.freitas@blip.ai',
  'marcela.ribeiro@blip.ai',
  'livia.monteiro@blip.ai',
  'luana.freitas@blip.ai',
  'kenia.silva@blip.ai',
];

export const N2_EMAILS = [
  'giselle.souza@blip.ai',
  'giselle.souza@stilingue.com.br',
  'joao.duarte@blip.ai',
  'joao.duarte@stilingue.com.br',
  'nicole.gomes@blip.ai',
  'rafael.rodrigues@blip.ai',
  'wilker.paula@blip.ai',
];

export const N4_EMAILS = [
  'leonardo.sa@blip.ai',
  'angelo.finassi@blip.ai',
  'eduardo.costa@blip.ai',
  'eduardo@stilingue.com.br',
  'gideao.frota@blip.ai',
  'heudes.araujo@blip.ai',
  'heudes.vinicius@stilingue.com.br',
  'isabela.felix@blip.ai',
  ...JANDEILSON_BORGES_EMAILS,
  'junior.lima@blip.ai',
  'kledilson.ferreira@blip.ai',
  'laura.lima@blip.ai',
  ...MAYARA_OLIVEIRA_EMAILS,
  'michele.andrade@blip.ai',
  'nando@stilingue.com.br',
  ...PRISCILA_EMAILS,
  'natalia.almeida@blip.ai',
  'pablo.menezes@blip.ai',
  'paula.souza@blip.ai',
];

export const PS_EMAILS = [
  'ana.cid@blip.ai',
  'ana.plentz@blip.ai',
  'ana.plentz@take.net',
  'arnaldo.macedo@blip.ai',
  'caroline.vicente@blip.ai',
  'clarel.filho@blip.ai',
  'dharuan.emina@blip.ai',
  'gabriel.marinelli@blip.ai',
  'juliana.maranhao@blip.ai',
  'juliana.maranhao@stilingue.com.br',
  'lucas.lins@blip.ai',
  'pedro.meirelles@blip.ai',
  'pedro.meirelles@stilingue.com.br',
  'vitor.aguiar@blip.ai',
  'pedro.gomes@blip.ai',
];

export const SI_EMAILS = [
  'raphael.dutra@blip.ai',
];

export const VENDAS_EMAILS = [
  'bruno.archanjo@blip.ai',
];

export const LIBERACOES_ACCESS_EMAILS = [
  ...LIBERACOES_EMAILS,
  ...N2_EMAILS,
  ...CEZAR_SILVA_EMAILS,
  ...MAYARA_OLIVEIRA_EMAILS,
  ...JANDEILSON_BORGES_EMAILS,
];

export const LIBERACOES_ACCESS_ALLOWLIST = new Set(LIBERACOES_ACCESS_EMAILS);

/**
 * Email allowlist — users in this list have general access to all routes
 * that are not restricted to a specific route allowlist.
 */
export const GENERAL_ACCESS_EMAILS = [...new Set([
  ...DBRE_EMAILS,
  ...LIBERACOES_EMAILS,
  ...N1_EMAILS,
  ...N2_EMAILS,
  ...N4_EMAILS,
  ...PS_EMAILS,
  ...SI_EMAILS,
  ...VENDAS_EMAILS,
])];

export const RESTRICTED_ROUTES = new Set([
  'universeLimit',
  'processRetweet',
  'addLanguage',
  'PostInsertion',
  'actionBablic',
  'configuration',
  'status',
  'podUpdate',
  'usergroupNew',
  'eyesActivationAndList',
  'multiple-edition',
  'benchmarksEdit',
  'reprocessingNew',
  'proprietaryRetroactiveNew',
  'retroactiveNew',
  'retroactiveNewMass',
  'brandHealth',
  'creditsByUsergroup',
  'liberation',
  'facebookProfiles',
  'instagramProfiles',
  'youtubeProfiles',
  'benchmarksAdmin',
  'panelReport',
]);

/**
 * Per-route email allowlists. When a route has an entry here, ONLY users in
 * this set may access it — GENERAL_ACCESS_EMAILS does not apply for that route.
 */
export const ROUTE_ALLOWLISTS = {
  liberacoesAuthorization: LIBERACOES_ACCESS_ALLOWLIST,
  benchmarksAdmin: LIBERACOES_ACCESS_ALLOWLIST,
  liberation: LIBERACOES_ACCESS_ALLOWLIST,
  brandHealth: LIBERACOES_ACCESS_ALLOWLIST,
};

const ROUTE_PERMISSION_ALIASES = {
  pageReport: 'panelReport',
  userReport: 'panelReport',
};

function getPermissionRoute(routeName) {
  return ROUTE_PERMISSION_ALIASES[routeName] || routeName;
}

/**
 * Returns true if the given user email is allowed to access the given route.
 *
 * @param {string|null|undefined} userEmail
 * @param {string} routeName
 * @returns {boolean}
 */
export function hasRouteAccess(userEmail, routeName) {
  if (process.env.NODE_ENV !== 'production') return true;
  const permissionRoute = getPermissionRoute(routeName);
  const routeAllowlist = ROUTE_ALLOWLISTS[permissionRoute];
  if (routeAllowlist) {
    return Boolean(userEmail && routeAllowlist.has(userEmail));
  }
  if (userEmail && GENERAL_ACCESS_EMAILS.includes(userEmail)) {
    return true;
  }
  return !RESTRICTED_ROUTES.has(permissionRoute);
}
